import { inject, injectable } from "inversify";
import type { IF360Validator } from "./F360Validator";
import {
  DIMixins,
  DITypes,
  DIValidators,
  FinancasUserRoles,
  LocalStorageKeys
} from "@/core/@types/types";
import { type IStorage } from "@/core/plugins/storage/Storage";
import "reflect-metadata";
import type { IUserProfileStorageMixin } from "@/core/plugins/storage/UserProfileStorageMixin";

@injectable()
export default class AcessoContabilValidator implements IF360Validator {
  @inject(DITypes.STORAGE)
  private storage!: IStorage;

  @inject(DIMixins.USER_PROFILE_STORAGE)
  userProfileMixin!: IUserProfileStorageMixin;

  @inject(DIValidators.CIELO)
  private cieloValidator!: IF360Validator;

  @inject(DIValidators.CADIS)
  private cadisValidator!: IF360Validator;

  private isCielo() {
    return this.cieloValidator.handleValidation();
  }

  private isCadis() {
    return this.cadisValidator.handleValidation();
  }

  private getRoles() {
    const roles = this.storage.get(LocalStorageKeys.userRules);

    return roles;
  }

  private getUserProfile() {
    const userProfile = this.userProfileMixin.handleGetUserProfile();

    return userProfile;
  }

  private isAtivacaoOculta(): boolean {
    const userProfile = this.getUserProfile();

    return userProfile?.NovoContabilAtivoOculto || false;
  }

  private isWebServiceUser(): boolean {
    const userProfile = this.getUserProfile();

    return userProfile?.Email?.includes("webservice") || false;
  }

  private hasNovoContabil() {
    const userProfile = this.getUserProfile();

    return userProfile?.TemNovoContabil || false;
  }

  private cannotAccess() {
    return this.isCadis() || this.isCielo();
  }

  handleValidation(): boolean {
    if (this.cannotAccess()) return false;

    const podeAcessarOculto =
      this.isAtivacaoOculta() && this.isWebServiceUser();

    if (podeAcessarOculto) return true;

    if (!this.hasNovoContabil()) return false;

    const hasContabilRole =
      this.getRoles()?.includes(FinancasUserRoles.CanalContador) || false;

    return hasContabilRole;
  }
}
